var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-grid p-fluid p-justify-center"},[_c('div',{staticStyle:{"width":"600px"}},[_c('Profile',{attrs:{"user-id":_vm.userId}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }